module.exports = __webpack_public_path__ + "static/media/noopur_karkare.c21bc3d8.png";